import type { RouteObject } from 'react-router-dom';

import { setPermissions } from '@/features/auth/authStore';
import { routes } from '@/router';
import type { RouterData } from '@/router/elegant/routes';
import { transformElegantRouteToReactRoute } from '@/router/elegant/transform';
import { PlatformAccountService } from '@/service/api/platform/index';
import type { MenuItemDto } from '@/service/api/platform/menu';
import { store } from '@/store';

import { getUserInfo } from '../auth';

interface InheritAttrs {
  sideShow?: boolean;
}
const routerDataHander = (treeList: MenuItemDto[], inheritAttrs: InheritAttrs = {}) => {
  const newTreeList: RouterData[] = [];
  treeList.forEach(tree => {
    const newTree: RouterData = {
      component: tree.component,
      errorBoundary: tree.errorBoundary,
      fallback: tree.fallback,
      handle: {
        activeMenu: tree.activeMenu,
        hideInMenu: inheritAttrs.sideShow === false ? true : !tree.sideShow,
        icon: tree.icon,
        title: tree.name
      },
      name: tree.mark,
      path: tree.pagePath,
      redirect: tree.redirect,
      type: tree.menuType
    };
    if (tree.children && tree.children.length) {
      newTree.children = routerDataHander(tree.children, {
        sideShow: !newTree.handle!.hideInMenu
      });
    }
    newTreeList.push(newTree);
  });
  return newTreeList;
};

export async function initAuthRoutes(addRoutes: (parent: string | null, route: RouteObject[]) => void) {
  // const authRouteMode = import.meta.env.VITE_AUTH_ROUTE_MODE;

  // const reactAuthRoutes = mergeValuesByParent(authRoutes);

  // const isSuper = isStaticSuper(store.getState());

  // const { roles } = selectUserInfo(store.getState());
  // debugger;

  // // 静态模式
  // if (authRouteMode === 'static') {
  //   // 超级管理员
  //   if (isSuper) {
  //     reactAuthRoutes.forEach(route => {
  //       addRoutes(route.parent, route.route);
  //     });
  //   } else {
  //     // 非超级管理员
  //     const filteredRoutes = filterAuthRoutesByRoles(reactAuthRoutes, roles);

  //     filteredRoutes.forEach(({ parent, route }) => {
  //       addRoutes(parent, route);
  //     });
  //   }
  // } else {
  // 动态模式
  // const { data, error } = await fetchGetUserRoutes();
  // if (error) {
  //   console.error(error);
  //   return;
  // }
  // const data: { routes: RouterData[] } = {
  //   routes: [
  //     {
  //       children: [
  //         {
  //           component: 'sync-manage/application/index',
  //           handle: { title: '应用列表' },
  //           name: 'syncManageApplication',
  //           path: 'application',
  //           type: 'C'
  //         },
  //         {
  //           component: 'sync-manage/system/index',
  //           handle: { title: '系统列表' },
  //           name: 'syncManageSystem',
  //           path: 'system',
  //           type: 'C'
  //         }
  //       ],
  //       component: 'base',
  //       handle: {
  //         icon: 'material-symbols-light:directory-sync',
  //         title: '同步管理'
  //       },
  //       name: 'syncManage',
  //       path: 'sync-manage',
  //       redirect: '/sync-manage/application',
  //       type: 'M'
  //     },
  //     {
  //       children: [
  //         {
  //           component: 'user-center/list/index',
  //           handle: {
  //             title: '用户列表'
  //           },
  //           name: 'userCenterList',
  //           path: 'list',
  //           type: 'C'
  //         },
  //         {
  //           component: 'user-center/list/[id]/index',
  //           handle: {
  //             activeMenu: '/user-center/list',
  //             hideInMenu: true,
  //             title: '用户详情'
  //           },
  //           name: 'userCenterDetail',
  //           path: ':id',
  //           type: 'C'
  //         },
  //         {
  //           component: 'user-center/net/index',
  //           handle: {
  //             title: '网体'
  //           },
  //           name: 'userCenterNet',
  //           path: 'net',
  //           type: 'C'
  //         },
  //         {
  //           component: 'user-center/relation-record/index',
  //           handle: {
  //             title: '关系变动'
  //           },
  //           name: '(base)_user-center_relation-record',
  //           path: 'relation-record',
  //           type: 'C'
  //         },
  //         {
  //           component: 'user-center/sync-record/index',
  //           handle: {
  //             title: '同步记录'
  //           },
  //           name: '(base)_user-center_sync-record',
  //           path: 'sync-record',
  //           type: 'C'
  //         }
  //       ],
  //       component: 'base',
  //       handle: {
  //         icon: 'material-symbols-light:person',
  //         title: '个人中心'
  //       },
  //       name: 'userCenter',
  //       path: 'user-center',
  //       redirect: '/user-center/list',
  //       type: 'M'
  //     },
  //     {
  //       children: [
  //         {
  //           children: [
  //             {
  //               component: 'system/permission/users/index',
  //               handle: { title: '管理员列表' },
  //               name: 'users',
  //               path: 'users',
  //               type: 'C'
  //             },
  //             {
  //               component: 'system/permission/roles/index',
  //               handle: { title: '角色管理' },
  //               name: 'roles',
  //               path: 'roles',
  //               type: 'C'
  //             },
  //             {
  //               component: 'system/permission/menus/index',
  //               handle: { title: '权限规则' },
  //               name: 'menus',
  //               path: 'menus',
  //               type: 'C'
  //             },
  //             {
  //               component: 'system/permission/white-list/index',
  //               handle: { title: '白名单管理' },
  //               name: 'whiteList',
  //               path: 'white-list',
  //               type: 'C'
  //             }
  //           ],
  //           handle: { title: '系统管理权限' },
  //           name: 'permission',
  //           path: 'permission',
  //           type: 'M'
  //         },
  //         {
  //           component: 'system/operation-logs/index',
  //           handle: { title: '操作日志' },
  //           name: 'operationLogs',
  //           path: 'operation-logs',
  //           type: 'C'
  //         }
  //       ],
  //       component: 'base',
  //       handle: {
  //         icon: 'material-symbols-light:directory-sync',
  //         title: '系统设置'
  //       },
  //       name: 'system',
  //       path: 'system',
  //       // redirect: '/system/application',
  //       type: 'M'
  //     },
  //     {
  //       children: [
  //         {
  //           component: 'internal/reset-password/index',
  //           handle: {
  //             hideInMenu: true,
  //             title: '修改密码'
  //           },
  //           name: 'internalResetPassword',
  //           path: 'reset-password',
  //           type: 'C'
  //         }
  //       ],
  //       component: 'base',
  //       name: 'internal',
  //       path: 'internal',
  //       type: 'M'
  //     }
  //   ]
  // };
  // store.dispatch(setHomePath(data.home));
  // function flat(parent, )

  // const filteredRoutes = filterAuthRoutesByDynamic(reactAuthRoutes, data.routes);

  // data.routes.forEach((route) => {
  //   // addRoutes(parent, route);
  // })
  // function filter(parent: string, routes:any[], newRoutes = []) {
  //   return routes.reduce((acc: any[], route) => {
  //     const newRoute = {
  //       ...route
  //     }
  //     if (route?.children?.length) {
  //       newRoute.children = []
  //       acc.pushfilter(newRoute.id, newRoute.children)
  //     }
  //     acc.push({
  //       parent,
  //       newRoute
  //     })
  //   }, [])
  // }
  await getUserInfo();
  const { data } = await PlatformAccountService.getMenus();
  const newMenus = routerDataHander(data!.menuList);
  store.dispatch(setPermissions(data!.permissionsList));
  addRoutes(
    'root',
    newMenus.flatMap(route => transformElegantRouteToReactRoute(routes[0], route))
  );
  // filteredRoutes.forEach(({ parent, route }) => {
  // });
  // }
}
